export default {
    mapGeofenceCreateEditGeofenceGroup_editTitle: "Edit Geofence Group: ",
    mapGeofenceCreateEditGeofenceGroup_createTitle: "Create New Geofence Group",
    mapGeofenceCreateEditGeofenceGroup_name: "Name",
    mapGeofenceCreateEditGeofenceGroup_success: "Geofence group saved successfully",
    mapGeofenceCreateEditGeofenceGroup_iconRequired: 'You must select an icon or disable "Geofence Group Icon" toggle, please try again',
    mapGeofenceCreateEditGeofenceGroup_groupAlreadyExists: "A group already exists with the name entered"
};